var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"menu"),React.createElement("path",{"fill":"#fff","d":"M3 13h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1zM3 7h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1zM3 19h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1z","key":1})]);
}

MenuInline.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
